import { useEffect, useState } from 'react';
import { useActions, useAppSelector } from 'state/store';
import { JobBody } from 'services/types';
import { usePostNewJobMutation } from 'services/newApi/jobsApi';
import {
  currentReportSelector,
  portfoliosRunReport,
} from 'state/store/selectors';
import { useLazyGetPortfoliosListQuery } from 'services/newApi/portfoliosApi';
import { PortfolioItem, RunReportForm } from '../types';

type UseRunReportForm = {
  form: RunReportForm;
  setForm: (form: RunReportForm) => void;
  runReport: () => void;
  isModalVisible: boolean;
  setModalVisible: (value: boolean) => void;
  isLoading: boolean;
};

export const useRunReportForm = (): UseRunReportForm => {
  const { setSelectedValuationDate } = useActions();
  const [postJob] = usePostNewJobMutation();
  const [isModalVisible, setModalVisible] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [portfolios, setPortfolios] = useState<PortfolioItem[]>([]);
  const portfoliosList = portfoliosRunReport(useAppSelector((state) => state));
  const report = currentReportSelector(useAppSelector((state) => state));
  const valuationState = useAppSelector((state) => state.valuationDatesState);
  const context = useAppSelector(
    (state) => state.contextsState.selectedContext
  );
  const [trigger, result] = useLazyGetPortfoliosListQuery();

  const runReport = async () => {
    if (
      valuationState &&
      valuationState.selectedValuationDate &&
      report?.reportConfigurationId
    ) {
      setLoading(true);

      const benchmarks: string[] = [];
      portfolios.forEach((portfolio) => {
        if (
          portfolio.benchmarkId !== null &&
          portfolio.benchmarkId !== undefined
        )
          benchmarks.push(portfolio.benchmarkId);
      });

      const body: JobBody = {
        portfolioIds: portfolios
          .map((portfolio) => portfolio.portfolioId)
          .concat(benchmarks),
        reportConfigId: report.reportConfigurationId,
        valuationDate: valuationState.selectedValuationDate,
      };

      await postJob({ body, context });

      setLoading(false);
      setModalVisible(false);
    }
  };

  if (result.isUninitialized && context) {
    trigger(context);
  }
  const setForm = (form: RunReportForm) => {
    if (form.portfolios) {
      setPortfolios(form.portfolios);
    }

    if (form.valuationDate) {
      if (valuationState.valuationDates?.includes(form.valuationDate)) {
        setSelectedValuationDate(form.valuationDate);
      }
    }
  };

  const form: RunReportForm = {
    name: report?.name,
    reportConfigId: report?.reportConfigurationId,
    valuationDate: valuationState.selectedValuationDate,
    portfolios,
  };
  useEffect(() => {
    if (isModalVisible && portfolios.length <= 0 && portfoliosList.length > 0) {
      setPortfolios(portfoliosList);
    }
  }, [isModalVisible, portfolios, portfoliosList]);

  return {
    form,
    setForm,
    isLoading,
    runReport,
    isModalVisible,
    setModalVisible,
  };
};
